// @flow
//Core
import React from 'react';
import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import OptimizedAsset from 'src/components/OptimizedAsset';
//Local
import { itemsStyles } from '../styles';
import typography from '../../../../styles/typography.module.scss';
import newsComponentsStyles from '../NewsComponents.module.scss';

const ColumnPostItem = ({
  itemUrl,
  previewImage,
  tags,
  title,
  index,
  subtitle,
  isDisabledImagesSaving,
}) => {
  const styles = itemsStyles({});

  return (
    <Grid
      xs={12}
      md={4}
      key={index}
      item
      className={newsComponentsStyles.newsCard}
    >
      <OutboundLink href={itemUrl} className={styles.cardWrapper}>
        <div className={classNames(styles.card, isMobile && styles.cardMobile)}>
          <OptimizedAsset
            src={previewImage}
            alt=""
            className={classNames(styles.cardImg, {
              [styles.imageDisableSaving]: isDisabledImagesSaving,
            })}
          />
          {tags && (
            <div className={classNames(styles.itemTag, typography.textSmDark)}>
              {tags}
            </div>
          )}
          <div className={styles.newsContent}>
            <h2 className={classNames(styles.title, typography.titleH7Dark)}>
              {title}
            </h2>
            <p className={classNames(styles.subtitle, typography.textSmDark)}>
              {subtitle}
            </p>
          </div>
        </div>
      </OutboundLink>
    </Grid>
  );
};

export default ColumnPostItem;
